import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import ptBR from 'vee-validate/dist/locale/pt_BR'
import { isCep, isCnpj, isCpf } from 'validator-brazil'

Vue.use(VeeValidate)

Validator.extend('unique', {
    validate(value, { currentValues }) {
        const found = currentValues.filter(current => current === value)
        return found.length === 0
    }
}, {
    paramNames: ['currentValues']
})

Validator.extend('cpf', {
    validate(value) {
        return isCpf(value)
    }
})

Validator.extend('cnpj', {
    validate(value) {
        return isCnpj(value)
    }
})

Validator.extend('cep', {
    validate(value) {
        return isCep(value)
    }
})

Validator.extend('tempo_etapa_lance', {
    paramNames: ['min', 'max'],
    validate(value, args) {
        const min = parseInt(args.min)
        const max = parseInt(args.max)

        if (!value) {
            return false
        }

        let horas = parseInt(value.trim().substring(0, value.indexOf(':')))
        let minutos = parseInt(value.trim().substring(value.indexOf(':') + 1))

        if (Number.isNaN(horas) || Number.isNaN(minutos)) {
            return false
        }

        const minutosTotaisEntrados = (horas * 60) + minutos

        if (min <= 0 && max <= 0)
            return minutosTotaisEntrados > 0

        if (minutosTotaisEntrados < min || minutosTotaisEntrados > max)
            return false

        return true

    }
})

const mensagenPersonalizada = (field, args) => {
    if (args[0] <= 0 && args[1] <= 0)
        return `O valor do campo ${field} deve ser maior que 0`

    const horasMin = Math.floor(args[0] / 60)
    const minutosMin = args[0] % 60
    const horasMax = Math.floor(args[1] / 60)
    const minutosMax = args[1] % 60

    const min = `${horasMin > 9 ? horasMin : '0'.concat(horasMin)}:${minutosMin > 9 ? minutosMin : '0'.concat(minutosMin)}`
    const max = `${horasMax > 9 ? horasMax : '0'.concat(horasMax)}:${minutosMax > 9 ? minutosMax : '0'.concat(minutosMax)}`
    return `O valor do campo ${field} deve estar entre ${min} e ${max} hs`
}

Validator.localize('pt-BR', ptBR)

Validator.localize({
    'pt-BR': {
        messages: {
            unique: field => `${field} duplicado`,
            cpf: field => `${field} inválido`,
            cnpj: field => `${field} inválido`,
            tempo_etapa_lance: (field, args) => mensagenPersonalizada(field, args),
            date_format: () => 'O campo não tem uma data válida',
            before: () => 'O campo tem uma data maior que a permitida',
            after: () => 'O campo tem uma data menor que a permitida'

        }
    }
})